import angular from "angular";

angular
    .module('app')
    .component('usersSelectModal', {
        template: require('./users-select-modal.html'),
        controller: ['$http', 'ErrorResponseParser', 'Notifier', '$scope', controller],
        bindings: {
            resolve: '<',
            close: '&',
            dismiss: '&'
        }
    });

function controller($http, ErrorResponseParser, Notifier, $scope) {

    let $ctrl = this;

    $ctrl.page = 1;
    $ctrl.search = null;
    $ctrl.type = null;
    $ctrl.perPage = '15';
    $ctrl.orderBy = 'id';
    $ctrl.orderDir = 'desc';

    $ctrl.$onInit = function () {
        $ctrl.course = $ctrl.resolve.course;
        $ctrl.getList();
    };

    $ctrl.submit = function () {

        $ctrl.loading = true;
        let items = [];

        $ctrl.users.forEach(function (user) {
            if (user.selected && !user.isset) {
                items.push({
                    user_id: user.id
                });
            }
        });

        $http.post(`/admin/courses/${$ctrl.course.id}/attach-users`, {items}).then(
            function (response) {
                $ctrl.loading = false;
                items = [];
                $ctrl.selectedAll = false;

                $ctrl.users.forEach(function (user) {
                    if (user.selected) {
                        user.isset = true;
                    }
                });

                Notifier.success('Данные успешно сохранены', 2);


            },
            function (error) {
                $ctrl.loading = false;
                if (!items || error.status == 422) {
                    Notifier.error('Выберите пользователей', 2);
                } else {
                    Notifier.error('Произошла ошибка с текстом:' + error.data.message, 2);
                }
            })
    };

    $ctrl.getList = function () {
        $http
            .get('/admin/courses/get-users-list', {
                params: {
                    page: $ctrl.page,
                    search: $ctrl.search,
                    type: $ctrl.type,
                    order_by: $ctrl.orderBy,
                    order_dir: $ctrl.orderDir,
                    per_page: $ctrl.perPage,
                    course_id: $ctrl.course.id,
                }
            })
            .then(
                function (response) {
                    $ctrl.users = response.data.data;
                    $ctrl.total = response.data.total;

                },
                function (error) {

                }
            );
    };

    $ctrl.toggleAll = function () {
        $ctrl.users.forEach(function (user) {
            user.selected = $ctrl.selectedAll;
        })
    };

    $ctrl.reset = function () {
        $ctrl.page = 1;
        $ctrl.search = null;
        $ctrl.type = null;
        $ctrl.getList();
    };

    $ctrl.doFilter = function () {
        $ctrl.page = 1;
        $ctrl.getList();
    };



}
